import useCookies from '@/composables/cookies/useCookies';

export default function useCrmCookies() {
    const cookies = useCookies();

    const formatCrmCookieKey = (prefix: string): string => `${prefix}Data`;

    return {
        getCrmCookie: <T = any>(key: string): T | null => cookies.get(formatCrmCookieKey(key)),
        setCrmCookie: (key: string, data: any): boolean => {
            if (!data || typeof data !== 'object') return false;

            cookies.set(formatCrmCookieKey(key), data);

            return true;
        },
        formatCrmCookieKey,
    };
}
